module.exports = __webpack_public_path__ + "static/media/route.4b777b36.svg";